import { render } from "./changePassword.vue?vue&type=template&id=5a102dd3&scoped=true"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"

import "./changePassword.vue?vue&type=style&index=0&id=5a102dd3&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境/M平台/前端/servicepartner.matchupexpo.com - 外呼合作方端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a102dd3"]])

export default __exports__